export enum EnrollmentOfferTypesEnum {
  Instant = 1,
  Bonus = 2,
}
